import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PayAsYouGo from '../components/PayAsYouGo';
import PaymentProcessing from '../components/PaymentProcessing';
import { getCurrentUserId } from '../services/database';


const PaymentPage = () => {
  
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showProcessing, setShowProcessing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    // Check if user is authenticated
    const checkAuth = async () => {
      try {
        const userId = await getCurrentUserId();
        if (!userId) {
          navigate('/login', { 
            state: { 
              returnTo: '/payment',
              message: 'Please log in to continue with your purchase.'
            } 
          });
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Auth check error:', error);
        setError('Authentication error. Please try again.');
        setIsLoading(false);
      }
    };
    
    checkAuth();
  }, [navigate]);
  
  // Handle plan selection
  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    setShowProcessing(true);
  };
  
  // Handle payment cancel
  const handlePaymentCancel = () => {
    setShowProcessing(false);
    setSelectedPlan(null);
  };
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
          <div className="text-red-500 mb-4">
            <svg
              className="w-16 h-16 mx-auto mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <p>{error}</p>
          </div>
          <button
            onClick={() => navigate('/projects')}
            className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800"
          >
            Return to Projects
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen font-sans antialiased bg-gray-50">
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
          Choose Your Plan
        </h1>
        
        <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto">
        Select a plan that works for you. All plans include full access to AI design features, flexible view and flow creation, and the ability to share and export your designs.
        </p>
        
        {showProcessing ? (
          <PaymentProcessing
            selectedPlan={selectedPlan}
            onCancel={handlePaymentCancel}
          />
        ) : (
          <div className="max-w-md mx-auto">
            <PayAsYouGo onSelectPlan={handleSelectPlan} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentPage;